import axios from "../axiosClient";

export const getReportConfigurations = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/ReportConfiguration/getall`, {
    params: { PageNumber, pageSize, SortBy, SortDirection, searchText },
    signal,
  });

  return res?.data;
};
